module.exports = __webpack_public_path__ + "static/media/user-pic.b603bb32.jpg";